<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                <h4 class="modal-title">{{ $t('exchange_rate') }}</h4>
            </div>
            <div class="p-20">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="alert alert_default t_center">
                            <div>
                                <span class="btn btn-warning btn-xs m-0 pull-right" @click="refresh()" v-pml-tooltip="$t('refresh')"><i class="fa fa-refresh"></i></span>
                                <strong>{{ $t('base_currency') }}:</strong> {{ tenant.currency_id | pmlCurrencyById('name') }}
                            </div>
                            <p class="m-t-10 m-b-5">
                                <strong class="show"><i class="fa fa-exclamation-triangle"></i> {{ $t('attention') }}! </strong>
                                {{ $t('use_base_currency_as_reference_to_others') }}
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="alert alert_default t_center">
                            <button class="btn btn-primary m-0" @click="fixerIoSync()">
                                <span class="btn-label">
                                    <i class="md-account-balance"></i>
                                </span>
                                {{ $t('update_exchange_rate_now') }}
                            </button>
                            <p class="m-t-5">{{ $t('data_provided_by') }} <a href="http://www.ecb.europa.eu/stats/exchange/eurofxref/html/index.en.html" target="_blank">European Central Bank</a></p>
                            <small class="show">{{ $t('if_required_the_values_can_be_edited') }}</small>
                        </div>
                    </div>
                </div>
                <hr class="m-0">
                <div class="row grid-structure" v-pml-block="isSyncing">
                    <PmlItem v-for="item in list" :key="item.id" :item="item"></PmlItem>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PmlItem from './Item.vue'
    import RoutedModals from '@/utils/mixins/routed-modals'
    import Notify from '@/utils/helpers/notify'
    import { trans } from '@/utils/helpers/translation'
    import { fixerIoSync, getAll } from '@/services/exchange-rate'
    import { mapGetters } from 'vuex'
    import { cloneDeep } from 'lodash'

    export default {
        name: 'ExchangeRateModal',
        mixins: [ RoutedModals ],
        components: { PmlItem },
        data () {
            return {
                list: [],
                isSyncing: false
            }
        },
        metaInfo () {
            return {
                title: trans('exchange_rate')
            }
        },
        computed: {
            ...mapGetters({
                'currencies': 'getCurrencies',
                'tenant': 'getTenant'
            })
        },
        mounted () {
            if (!['premium_power_sales'].includes(this.tenant.stripePlan))
                this.$router.push({ name: 'error.404' })
            this.list = cloneDeep(this.currencies)
        },
        watch: {
            'currencies' (val) {
                this.list = cloneDeep(this.currencies)
            }
        },
        methods: {
            fixerIoSync () {
                this.isSyncing = true

                fixerIoSync()
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isSyncing = false })
            },
            refresh () {
                this.isSyncing = true

                getAll()
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isSyncing = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/exchange_rate/components/Main.vue